import React, { Fragment } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Separator from '../Separator';
import config from '../../../helpers/config';
import { Grid, Typography, ExpansionPanel , ExpansionPanelSummary , Summary, ExpansionPanelDetails } from '@material-ui/core';

const useStyles = makeStyles(theme => ({

    root: {
        '&:before': {
            backgroundColor: 'transparent'
        },
        '&.MuiPaper-elevation1': {
            boxShadow: 'none'
        },
        '&.Mui-expanded': {
            margin: 0
        },
        '&.MuiPaper-root': {
            backgroundColor: 'transparent'
        }
    },

    content: {
        '&.Mui-expanded': {
            margin: '10px 0'
        }  
    },
    desc: {
        // fontWeight: 500,
        letterSpacing: 3,
        color: '#6f635d'
    },

    hr: {
        height: '1px',
        backgroundImage: 'linear-gradient(to right, #ac9f97 50%, rgba(255,255,255,0) 0%)',
        backgroundPosition: "bottom",
        backgroundSize: "10px 1px",
        backgroundRepeat: "repeat-x",
    },
    image: {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: '50%',
        border: '3px solid #d1cac6',
        height: 400,
        width: 400,
        margin: '0 auto',

        [theme.breakpoints.down("lg")]: {
            height: 300,
            width: 300,
        },

        [theme.breakpoints.down("xs")]: {
            height: 200,
            width: 200,
        }
    },

    separator: {
        height: 50,
        width: '100%',
        backgroundColor: "transparent"
    },
}));

const titleStyle = makeStyles(theme => ({
    container: props =>({
        width: 350,
        borderBottom: `4px solid ${props.themeColor}`,
        borderRadius: '5px',
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '5px 5px 5px 15px',

        '& h3': {
            paddingLeft: 15
        },

        '& > div': {
            display: 'inline-flex'
        },

        '& .leftBorder': {
            position: 'absolute',
            width: 4,
            top: '65%',
            left: 0,
            bottom: 0,
            backgroundColor: props.themeColor
        },

        [theme.breakpoints.down("xs")]: {
            width: '100%',
        }

    }),
    icon: props => ({
        backgroundImage: `url(${config.S3Endpoint}${props.icon})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        width: 50,
        height: 50
    })
}));

const Title = (props) => {
    const classes = titleStyle(props);
    const { name, icon } = props; 
    return (
        <div className={classes.container}>
            <div className="leftBorder" />
            <div className={classes.icon} />
            <div><Typography variant="h3"><b>{name}</b></Typography></div>
        </div>
    )
}

export default (props) => {
    const classes = useStyles(props);
    const { direction, name, items, imgUrl, imgStyle, themeColor, iconUrl } = props; 
    return (
        <div>      
            <Separator classes={{root: classes.separator}} />
            <Grid container direction={direction} alignItems="center" justify="center">
                {/* image */}
                <Grid item xs={12} sm={6} md={5} lg={4}>
                    <div className={classes.image} style={{...imgStyle, backgroundImage: `url(${config.S3Endpoint}${imgUrl})`}} />
                </Grid>
                {/* list */}
                <Grid item xs={12} sm={6} md={7} lg={8}>
                    <Title themeColor={themeColor} name={name} icon={iconUrl} />
                    {items.map((item, i) => (
                        <div key={i}>
                            <div className={classes.hr} style={{display: i === 0 ? 'none' : 'block'}}></div>
                            <ExpansionPanel classes={{root: classes.root}}>
                                <ExpansionPanelSummary
                                    classes={{content: classes.content}}
                                    expandIcon={<ExpandMoreOutlinedIcon />}
                                    aria-controls="panel1a-content">
                                    <Typography variant="h4" className={classes.title}>{item.name}</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Typography variant="h5" className={classes.desc}>{item.desc}</Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        </div>
                    ))}  
                </Grid>
            </Grid>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/cares/ListImageContainer.js